import { DcfSdkEnumsObj } from "../../enums/DcfSdkEnum";
import { ErrorCodesObj, getErrorCode, mapErrorCode, NOT_SUPPORTED_ERROR_CODE, SomethingWentWrongErrorCodesObj, } from "../../helpers/ErrorMapper";
var ID_FORMAT_UNSUPPORTED = "ID_FORMAT_UNSUPPORTED";
var VISA_CONSUMER_FIELD_PATHS = {
    emailAddress: "consumer.emailAddress",
    mobileNumber: "consumer.mobileNumber",
};
var getHttpStatus = function (error) {
    if (error.reason === null || typeof error.reason !== "object")
        return undefined;
    var providerReason = error.reason;
    var status = Number(providerReason.status);
    if (Number.isInteger(status))
        return status;
    var code = Number(providerReason.code);
    return Number.isInteger(code) ? code : undefined;
};
var isTrustedCardFieldError = function (error, reasonCode) {
    if (reasonCode === ErrorCodesObj.CARD_EXP_INVALID ||
        reasonCode === ErrorCodesObj.CARD_SECURITY_CODE_MISSING) {
        return true;
    }
    return reasonCode === ErrorCodesObj.CARD_INVALID && error.dcf === DcfSdkEnumsObj.VISA;
};
var referencesExactPath = function (message, path) {
    var start = message.indexOf(path);
    if (start < 0) {
        return false;
    }
    var previousCharacter = message[start - 1];
    var nextCharacter = message[start + path.length];
    var hasPreviousBoundary = previousCharacter === undefined || !/[A-Za-z0-9_]/.test(previousCharacter);
    var hasNextBoundary = nextCharacter === undefined || !/[A-Za-z0-9_]/.test(nextCharacter);
    return hasPreviousBoundary && hasNextBoundary;
};
var getVisaFieldError = function (error) {
    if (error.dcf !== DcfSdkEnumsObj.VISA ||
        error.reason === null ||
        typeof error.reason !== "object" ||
        error.reason.reason !== ID_FORMAT_UNSUPPORTED ||
        typeof error.reason.message !== "string") {
        return undefined;
    }
    var reason = error.reason;
    var referencedFields = Object.entries(VISA_CONSUMER_FIELD_PATHS)
        .filter(function (_a) {
        var path = _a[1];
        return referencesExactPath(reason.message, path);
    })
        .map(function (_a) {
        var field = _a[0];
        return field;
    });
    if (referencedFields.length !== 1) {
        return undefined;
    }
    return {
        field: referencedFields[0],
        code: "INVALID_FORMAT",
    };
};
var adaptGeneralError = function (error) {
    var providerReasonCode = getErrorCode(error);
    var httpStatus = getHttpStatus(error);
    var isAmbiguousMastercardCardError = error.dcf === DcfSdkEnumsObj.MASTERCARD && providerReasonCode === ErrorCodesObj.CARD_INVALID;
    var shouldReturnToCardStep = isTrustedCardFieldError(error, providerReasonCode);
    var isGeneralAddCardHttpError = (httpStatus === 400 || httpStatus === 403) && !shouldReturnToCardStep;
    return {
        error: {
            dcf: error.dcf,
            reason: isAmbiguousMastercardCardError || isGeneralAddCardHttpError
                ? ErrorCodesObj.CARD_ADD_FAILED
                : providerReasonCode === undefined ||
                    mapErrorCode(providerReasonCode) === NOT_SUPPORTED_ERROR_CODE
                    ? SomethingWentWrongErrorCodesObj.SERVICE_ERROR
                    : providerReasonCode,
        },
        shouldReturnToCardStep: shouldReturnToCardStep,
    };
};
/** Converts Consumer checkout failures into field errors or display-safe translated errors. */
export var adaptConsumerCheckoutErrors = function (errors) {
    var fieldErrors = [];
    var generalErrors = [];
    var shouldReturnToCardStep = false;
    errors.forEach(function (error) {
        var fieldError = getVisaFieldError(error);
        if (fieldError) {
            fieldErrors.push(fieldError);
        }
        else {
            var generalError = adaptGeneralError(error);
            shouldReturnToCardStep || (shouldReturnToCardStep = generalError.shouldReturnToCardStep);
            generalErrors.push(generalError.error);
        }
    });
    return { fieldErrors: fieldErrors, generalErrors: generalErrors, shouldReturnToCardStep: shouldReturnToCardStep };
};
